import { CreateMessageSetV2, CreateMessageSetV2Variables } from './__generated__/CreateMessageSetV2'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateMessageSetV2($input: CreateMessageSetInputV2!) {
    createMessageSet: createMessageSetV2(input: $input) {
      __typename
      ... on MessageSetV2 {
        id
        title
        public
        dynamic
        rssUrl
        isNote
        messages {
          id
          text
          characters
          cardSize
        }
      }
      ... on MessageSetErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreateMessageSet = () => useMutation<CreateMessageSetV2, CreateMessageSetV2Variables>(MUTATION)
